import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { sharedStyles } from './shared/sharedStyles';

function NotFound() {
  const navigate = useNavigate();
  const { isSignedIn } = useUser();

  const handleGoHome = () => {
    // Navigate to dashboard if signed in, landing page if not
    navigate(isSignedIn ? '/dashboard' : '/');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: sharedStyles.colors.background,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        ...sharedStyles.glassCard,
        maxWidth: '600px',
        width: '100%',
        padding: '60px 40px',
        textAlign: 'center'
      }}>
        {/* 404 Number */}
        <div style={{
          fontSize: '120px',
          fontWeight: 'bold',
          background: `linear-gradient(135deg, ${sharedStyles.colors.primary}, ${sharedStyles.colors.accent})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          lineHeight: '1',
          marginBottom: '20px'
        }}>
          404
        </div>

        {/* Heading */}
        <h1 style={{
          fontSize: '32px',
          fontWeight: 'bold',
          color: sharedStyles.colors.textPrimary,
          marginBottom: '16px'
        }}>
          Page Not Found
        </h1>

        {/* Description */}
        <p style={{
          fontSize: '18px',
          color: sharedStyles.colors.textSecondary,
          marginBottom: '40px',
          lineHeight: '1.6'
        }}>
          Sorry, we couldn't find the page you're looking for.
          It might have been moved or doesn't exist.
        </p>

        {/* Action Button */}
        <button
          onClick={handleGoHome}
          style={{
            background: `linear-gradient(135deg, ${sharedStyles.colors.primary}, ${sharedStyles.colors.accent})`,
            color: 'white',
            fontSize: '16px',
            fontWeight: '600',
            padding: '14px 32px',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 14px rgba(234, 88, 12, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(234, 88, 12, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 14px rgba(234, 88, 12, 0.3)';
          }}
        >
          {isSignedIn ? 'Go to Dashboard' : 'Go to Homepage'}
        </button>

        {/* Optional: Add a subtle icon or illustration */}
        <div style={{
          marginTop: '40px',
          opacity: 0.6
        }}>
          <svg
            width="200"
            height="160"
            viewBox="0 0 200 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: '0 auto', display: 'block' }}
          >
            {/* Simple microphone illustration (matching your brand) */}
            <rect x="85" y="20" width="30" height="80" rx="15" fill={sharedStyles.colors.primary} opacity="0.3" />
            <rect x="90" y="100" width="20" height="30" fill={sharedStyles.colors.accentBrown} opacity="0.3" />
            <rect x="75" y="125" width="50" height="5" rx="2.5" fill={sharedStyles.colors.accentBrown} opacity="0.3" />
            <path d="M100 105 Q85 115, 85 130" stroke={sharedStyles.colors.accentBrown} strokeWidth="3" fill="none" opacity="0.3" />
            <path d="M100 105 Q115 115, 115 130" stroke={sharedStyles.colors.accentBrown} strokeWidth="3" fill="none" opacity="0.3" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
